import { useRoute, useRouter } from 'vue-router'
import { useMemberAuth } from '@/composables/useMemberAuth'

/**
 * 함우리몰은 로그인 회원만 본다. 비회원이 회원 동작에 들어가면 로그인으로 보낸다.
 */
export function useMallAuth() {
  const route = useRoute()
  const router = useRouter()
  const { isLoggedIn } = useMemberAuth()

  /** 비회원이면 로그인 화면으로 보내고 false 를 돌려준다. 로그인 후 원래 자리로 돌아온다. */
  const ensureLoggedIn = (redirectTo?: string): boolean => {
    if (isLoggedIn.value) return true

    router.push({
      path: '/login',
      query: { redirect: redirectTo ?? route.fullPath },
    })
    return false
  }

  return { isLoggedIn, ensureLoggedIn }
}
